import React, { useEffect, useMemo, useState } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";
import * as d3 from "d3";

import "./style/style.scss";
import "./style/animation.scss";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import bild_zone_pitch from "../../../assets/wc/videos/heatmap.webm";
import getContentById from "../../../../shared/utils/getContentById";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { getPlayerHeatmapStats } from "../../../../shared/utils/opta/statsHandler";
import anime from "animejs";
import { BildPlayerTriko } from "../../_partials/BildPlayerTriko/Index";


const getMainBackground = () => {
  return assets.background_1920;
};

const renderHeatmap = (input, id, animation) => {
  const inputFake = input;

  $(`#${id} #heatmap-${id} svg`).remove();
  // IFAB regulations (105x68 meters)
  const margin = { top: 50, right: 50, bottom: 50, left: 50 },
    // width = 891 - margin.left - margin.right,
    // height = 577 - margin.top - margin.bottom;
    width = 1200 - margin.left - margin.right,
    height = 800 - margin.top - margin.bottom;

  const svg = d3
    .select(`#heatmap-${id}`)
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`);

  // Add X axis
  const x = d3
    .scaleLinear()
    .domain([0, 100])
    .range([margin.left, width - margin.right]);
  svg.append("g").attr("transform", `translate(0, ${height})`);
  // .call(d3.axisBottom(x));

  // Add Y axis
  const y = d3
    .scaleLinear()
    .domain([0, 100])
    .range([height - margin.bottom, margin.top]);
  svg.append("g");
  // .call(d3.axisLeft(y));

  const color = d3
    .scaleLinear()
    .domain([0, 0.1, 0.15, 0.2, 0.3, 0.45, 0.65])
    .range(["lightgreen", "green", "yellow", "orange", "red", "darkred"]);

  // compute the density data
  const densityData = d3
    .contourDensity()
    .x(function (d) {
      return x(d.x);
    })
    .y(function (d) {
      return y(d.y);
    })
    .weight(100)
    .size([width, height])
    .bandwidth(15)
    .thresholds(15)
    .cellSize(1)(inputFake);
  // Add animation to draw the heatmap paths gradually

  const paths = svg
    .insert("g", "g")
    .selectAll("path")
    .data(densityData)
    .enter()
    .append("path")
    .attr("d", d3.geoPath())
    .attr("stroke", "transparent")
    .attr("stroke-width", 0)
    .attr("fill", function (d) {
      return color(d.value);
    });

  return {
    paths,
  };
};

export default function Index({ animation, data, mode, format, ...props }) {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const { t } = useTranslation();
  const [heatmapReturn, setHeatmapReturn] = useState();
  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const templateName = data?.template_name ?? "";

  const isTimeline = props.isTimeline;
  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };
  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name
        });
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);
  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const color1 = getContentById("color1", options);
  const color2 = getContentById("color2", options);
  // const headline = getContentById('headline', fields);
  const position = getContentById("playerPosition", fields);

  const teamHome = _.get(dynamic, "assets.teamHome");
  const teamAway = _.get(dynamic, "assets.teamAway");
  const matchInfo = _.get(dynamic, "optaMatchInfo");
  const matchday = _.get(dynamic, "matchday");
  const playerStats = _.get(dynamic, "stats");
  const teamSide = getContentById("selectedSide", fields);
  const heatmap = useMemo(() => {
    return _.get(dynamic, "heatmap", []).map(e => ({
      ...e,
      x: teamSide === 'away' ? 100 - e?.x : e?.x,
      y: teamSide === 'away' ? 100 - e?.y : e?.y
    }));
  }, [dynamic?.heatmap]);
  const backgroundImage = getMainBackground(format, teamSide);

  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];

  const teamHomeAlpha2 = getOptaCountryCode(
    homeTeam?.name,
    homeTeam?.shortName,
    homeTeam?.code,
  );
  const teamAwayAlpha2 = getOptaCountryCode(
    awayTeam?.name,
    awayTeam?.shortName,
    awayTeam?.code,
  );

  const competitionId = matchInfo?.competition?.id;

  // const targetAlpha = teamSide === "home" ? teamHomeAlpha2 : teamAwayAlpha2;
  const targetAlpha = teamSide === "home" ? homeTeam?.id : awayTeam?.id;

  const targetStats = ["touches", "fouls"];

  const kits = _.get(dynamic, "kits");
  const reversePlayerMapping = _.get(dynamic, "reversePlayerMapping");

  const playerHome = {
    ...playerStats,
    person: {
      ...playerStats?.person,
      surname: playerStats?.shortLastName,
      id: reversePlayerMapping?.[playerStats?.playerId]
    }
  };
  const homeStats = _.get(playerHome, "stat", []);
  const playerStatsParsed = getPlayerHeatmapStats(homeStats);
  useEffect(() => {
    if (heatmap.length) {
      const heatmapOut = renderHeatmap(heatmap, id, animation);
      setHeatmapReturn(heatmapOut);
    }
  }, [heatmap]);

  useEffect(() => {
    if (heatmapReturn && animation) {
      const { paths } = heatmapReturn;
      const stagger = 80; // Adjust this value to control the stagger effect

      const totalAnimationDuration = 1200; // Total duration of animation in milliseconds

      paths.each(function (d, i) {
        const path = d3.select(this);
        const totalLength = path.node().getTotalLength();

        path
          .attr("stroke-dasharray", totalLength + " " + totalLength)
          .attr("stroke-dashoffset", totalLength)
          .attr("opacity", "0"); // Start with opacity 0
      });

      const timeout1 = setTimeout(() => {
        // 🔥 Fade in background pitch image when animation starts
        const pitchImage = document.querySelector(`#${id} .heatmap-pitch`);
        if (pitchImage) {
          pitchImage.style.opacity = "0";
        }

        paths.each(function (d, i) {
          const path = d3.select(this);
          const totalLength = path.node().getTotalLength();

          // Create an anime.js animation
          anime({
            targets: path.node(),
            strokeDashoffset: [totalLength, 0],
            opacity: [0, 1],
            // translateX: [-200, 0],
            // scale: [2, 1],
            // scale: [0, 1],
            duration: totalAnimationDuration,
            delay: i * stagger, // Use the stagger value here
            // easing: "easeOutQuint",
            easing: "easeOutSine",
          });
        });
      }, 2500);

      const arrowsHeatmap = document.querySelector(`#${id} .bild-heatmap-arrows-right`);
      if (arrowsHeatmap) {
        arrowsHeatmap.style.opacity = "0.2";
      }
    }
  }, [heatmapReturn, animation]);


  const team = teamSide === "home" ? homeTeam : awayTeam;
  const bildMatch = dynamic?.matchInfo;
  const bildhomeTeam = bildMatch?.home;
  const bildawayTeam = bildMatch?.away;
  console.log('playerHome: ', playerHome)
  return (
    <div
      id={id}
      className={`T_${templateName} ${animation ? "animation" : ""} side-${teamSide}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("Heatmap", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={bildhomeTeam}
              awayTeam={bildawayTeam}
              matchInfo={bildMatch}
            />
          </div>
        }
        <div className="wc-content wc-content-v2">
          <ProgressBar height="8px" />

          <div className="main-content-side">
            <div className={"left-block-side"}>
              <BildPlayerTriko
                className={"player-position"}
                player={playerHome}
                teamId={targetAlpha}
                side={teamSide}
                bgColor={kits?.[teamSide]?.colour1}
                team={teamSide === 'home' ? bildhomeTeam : bildawayTeam}
                competitionId={competitionId}
                position={t(playerHome?.position === "Substitute" ? playerHome?.subPosition : playerHome?.position, { keyPrefix: "templates" })}
              />
              {/* <div className="teams-block">
                <div className={`team-logo-container ${teamSide}`}>
                  <Image
                    className="team-logo"
                    src={getDynamicLogoPath({ team: team, competitionId })}
                  />
                </div>
                <div className={`team-name ${teamSide}`}>
                  {t(team?.name, {
                    ns: "countries",
                  })}
                </div>
              </div> */}
              <div className="left-block-shadow"></div>
            </div>

            <div className={"center-block-side"}>
              <div
                className={`heatmap-block`}
              >
                <video
                  className="video-pitch"
                  width="100%"
                  height="100%"
                  controls={false}
                  muted={true}
                  autoPlay={false}
                  loop={false}>
                  <source src={bild_zone_pitch} type="video/mp4" />
                </video>
                <div className={"pitch-container"}>
                  <div id={`heatmap-${id}`} className={`player-heatmap`}
                    width="100%"
                    height="100%"></div>
                  <img className={"heatmap-pitch"} src={assets.heatmap_pitch}
                    width="100%"
                    height="100%" />
                  <div className={`bild-heatmap-arrows-right direction-${teamSide === "home" ? "right" : "left"}`}>
                    <img src={assets.right_arrow} />
                    <img src={assets.right_arrow} />
                    <img src={assets.right_arrow} />
                  </div>
                </div>
                <div className={"stats-block"}>
                  {playerStatsParsed.map((statRowHome, index) => {
                    return (
                      <React.Fragment key={"stats1" + statRowHome.type}>
                        <div className={`stat-row`}>
                          <div className={"stat-label"}>
                            {t(statRowHome?.type, { keyPrefix: "stats" })}
                          </div>
                          <div className={"stat-value"}>
                            {statRowHome?.value || "0"}
                          </div>
                        </div>
                        {index < playerStatsParsed.length - 1 && (
                          <div className={"stat-separator"}></div>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

        </div>
      </TemplateBlock >
    </div >
  );
}
